import $ from 'jquery'

$(document).ready(function(){
  $('#admin_user_submit').click(function(){
    var emailValue = document.getElementById('select2-admin-email-container')
    var AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content')
    $(this).prop('disabled', true)
    $.ajax({
      method: 'POST',
      data: {email: emailValue.title, authenticity_token: AUTH_TOKEN},
      url: "/admin/admin_users/add_privilage"
    }).then(function(response){
      if (response.status === 'ok') {
        window.location.href = response.redirect_url;
        $("#success_notification").removeClass('hidden');
        $("#success_notification").append(`<p>${response.message}</p>`);
      } else {
        $("#error_notification").removeClass('hidden');
        $("#error_notification").append(`<p>${response.message}</p>`);
      }
    }).always(function(){
      $(this).prop('disabled', false)
    })
  })
})